import type { HTMLProps } from "react"
import { forwardRef, useState } from "react"

import { TextField } from "./TextField"

type Props = Omit<HTMLProps<HTMLInputElement>, "type"> & {
  isError?: boolean
  errorMessage?: string
}

// アイコン定義は shadcn/Input.tsx と同じものを使用
const EyeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-5 w-5">
    <path
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const EyeOffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-5 w-5">
    <path
      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="1"
      y1="1"
      x2="23"
      y2="23"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * パスワード入力用のTextField。
 * 目のアイコンによるマスク表示/非表示の切替機能を持つ。
 */
export const PasswordTextField = forwardRef<HTMLInputElement, Props>(({ className, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="relative">
      <TextField
        {...props}
        ref={ref}
        type={showPassword ? "text" : "password"}
        maxLength={256}
        className={`pr-10 ${className || ""}`}
      />
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="absolute right-2 top-[40%] -translate-y-1/2 cursor-pointer border-none bg-transparent p-1 text-[#9fa6ad] hover:text-[#32383e]"
        aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示"}
      >
        {showPassword ? <EyeIcon /> : <EyeOffIcon />}
      </button>
    </div>
  )
})
